import { compact, flatMap, flow, join } from 'lodash/fp';

export const flattenCompactAndJoin = flow(flatMap, compact, join(','));
export const flattenCompactAndJoinSemicolon = flow(flatMap, compact, join(';'));
